import {PortChunk} from "../../chunks/types/PortChunk";
import {getSpreadOpFromPortDeclChunk} from "./getSpreadOpFromPortDeclChunk";

export function getSpreadOpFromPortChunk(
  portChunk: PortChunk
): string | null {
  const {
    captures: {
      2: portDeclChunk
    }
  } = portChunk;
  return getSpreadOpFromPortDeclChunk(portDeclChunk);
}
